import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { CompositionsClient, compositionsApiRef } from './api';
import { rootRouteRef } from './routes';

export const compositionsPlugin = createPlugin({
  id: 'compositions',
  apis: [
    createApiFactory({
      api: compositionsApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new CompositionsClient({ discoveryApi, fetchApi }),
    }),
  ],
  routes: { root: rootRouteRef },
});

export const CompositionsPage = compositionsPlugin.provide(
  createRoutableExtension({
    name: 'CompositionsPage',
    component: () =>
      import('./components/CompositionsPage').then(m => m.CompositionsPage),
    mountPoint: rootRouteRef,
  }),
);
